import { render, staticRenderFns } from "./UcInvoiceLines.yaml?vue&type=template&id=620883e4&component"
import script from "./UcInvoiceLines.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceLines.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports